import React from 'react';
import * as XLSX from 'xlsx';
import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';

const ExportToExcel = ({ data, fileName, isMobile }) => {
    const { t } = useTranslation();
    const handleExport = () => {
        if (!data || data.length === 0) {
            alert('No hay datos para exportar.');
            return;
        }

        // Exclude 'usuarioId' and 'feriaId' columns
        const filteredData = data.map(({ usuarioId, feriaId, ...rest }) => rest);

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Contactos");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    return (
        <IconButton className="edit-order-button" onClick={handleExport} title="Exportar a Excel">
            <DownloadIcon style={{ color: '#1B448F', fontSize: '2.5rem', marginRight: isMobile ? '10px' : '0px' }} />
            {isMobile && (
                <span>{t('downloadData')}</span>
                )
            }
        </IconButton>
    );
};

export default ExportToExcel;
